<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

import { userMenu } from '@/Support/Users/userMenu'
import { userData as user } from '@/Support/Users/userData'
import { logout } from '@/Support/Routing/Functions/logout'
import { router } from '@inertiajs/vue3'
import IndividualMembershipBadge from '@/Components/App/Memberships/IndividualMembershipBadge.vue'

const navigate = (route: string, close: unknown) => {
  close()
  router.get(route)
}
</script>

<template>
  <Menu v-slot="{ close }" as="div" class="ml-4 relative shrink-0">
    <div>
      <MenuButton
        class="bg-white rounded-full flex text-sm ring-2 ring-white/20 focus:outline-hidden focus:ring-opacity-100 relative"
      >
        <span class="sr-only">
          {{ __('Open user menu') }}
        </span>
        <img
          class="h-8 w-8 rounded-full object-cover"
          :src="user.profilePhotoUrl"
          alt=""
        />
      </MenuButton>
    </div>
    <transition
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="origin-top-right z-40 absolute -right-2 mt-2 w-48 rounded-md shadow-lg py-1 backdrop-blur-xs bg-white/60 dark:bg-neutral-700/50 ring-1 ring-black/5 focus:outline-hidden"
      >
        <MenuItem v-for="item in userMenu" :key="item.name" v-slot="{ active }">
          <a
            :class="[
              active ? 'bg-neutral-100 dark:bg-neutral-600' : '',
              'block px-4 py-2 text-sm text-neutral-700 dark:text-neutral-200 cursor-pointer',
            ]"
            @click="navigate(item.url, close)"
          >
            <p
              class="text-base font-medium text-neutral-900 dark:text-neutral-200"
            >
              {{ item.name }}
            </p>
            <p class="text-xs text-neutral-500 dark:text-neutral-400">
              {{ item.description }}
            </p>
          </a>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <p
            :class="[
              active ? 'bg-neutral-100 dark:bg-neutral-600' : '',
              'block px-4 py-2 text-sm text-neutral-700 dark:text-neutral-200 cursor-pointer cursor-pointer',
            ]"
            @click="logout"
          >
            {{ __('Log out') }}
          </p>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
